import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Divider, Icon } from '@paypalcorp/ppods-react'
import MenuLink from './MenuLink'
import { recordDynamicEvent } from '../common/analytics/utils'

const MenuItem = ({ item, isActive, isOpen, onChevronClick, location }) => {
  const addFPTI = (menuItem, subItem) => {
    const excludeItem = ['Braintree GraphQL API', 'Demo portal', 'API status']
    if (!excludeItem.includes(subItem.label)) {
      const mergedBothTitle = subItem.label
        ? `${menuItem.label}_${subItem.label}`
        : menuItem.label
      const eventName = mergedBothTitle
        .toLowerCase()
        .replace(/[&/]/g, '')
        .replace(/\s+/g, '_')
      recordDynamicEvent(
        `developer_dashboard,click,developer_dashboard_menu_${eventName}`,
      )
    }
  }

  const content = (
    <span className="header-nav__icon-container">
      <span className="header-nav__icon-bg">
        <Icon
          name={item.icon}
          size="18"
          aria-label={item.icon}
          aria-hidden="true"
        />
      </span>
      <span className="header-nav__label-container">
        <p className="header-nav__label">{item.label}</p>
      </span>
    </span>
  )

  return (
    <li
      key={item.path || item.menuKey}
      className={`header-nav__item${
        isActive ? ' header-nav__item--active' : ''
      }${isOpen ? ' header-nav__item--open' : ''}`}
    >
      {item.hasChevron ? (
        <div
          className={`header-nav__link${
            isActive ? ' header-nav__link--active' : ''
          }`}
          onClick={() => onChevronClick(item.menuKey)}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {content}
          <span style={{ marginLeft: 'auto' }}>
            <Icon
              name="chevron-right"
              size="18"
              aria-label="chevron-right"
              aria-hidden="true"
              style={{
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s',
              }}
            />
          </span>
        </div>
      ) : (
        <MenuLink
          item={item}
          isActive={isActive}
          addFPTIHandler={() => addFPTI(item, '')}
        >
          {content}
        </MenuLink>
      )}

      {/* Submenu */}
      {item.hasChevron && item.submenu && isOpen && (
        <ul className="header-nav__submenu">
          {item.submenu.map((sub) => {
            const isSubActive = location.pathname === sub.path
            return (
              <li
                key={sub.path}
                className={`header-nav__item header-nav__submenu-item${
                  isSubActive ? ' header-nav__item--active' : ''
                }`}
              >
                <MenuLink
                  item={sub}
                  isActive={isSubActive}
                  addFPTIHandler={() => addFPTI(item, sub)}
                >
                  <p className="header-nav__label">
                    {sub.label} {sub.icon}
                  </p>
                </MenuLink>
              </li>
            )
          })}
        </ul>
      )}
    </li>
  )
}

const LeftSideBarMenu = ({ menuItems }) => {
  const location = useLocation()
  const [openMenu, setOpenMenu] = useState(null)

  // Expand parent if current path matches any submenu
  useEffect(() => {
    const parentWithActiveSub = menuItems.find(
      (item) =>
        item.hasChevron &&
        item.submenu &&
        item.submenu.some((sub) => sub.path === location.pathname),
    )
    if (parentWithActiveSub) {
      setOpenMenu(parentWithActiveSub.menuKey)
    }
  }, [location.pathname, menuItems])

  const handleChevronClick = (menuKey) => {
    setOpenMenu((prevKey) => (prevKey === menuKey ? null : menuKey))
  }

  return (
    <>
      <nav className="header-nav header-nav--primary">
        <ul className="header-nav__list">
          {menuItems.map((item) => {
            // Highlight parent if submenu is closed and a submenu is active
            const isSubActive =
              item.hasChevron &&
              item.submenu &&
              item.submenu.some((sub) => sub.path === location.pathname)
            const isActive =
              location.pathname === item.path ||
              (isSubActive && openMenu !== item.menuKey)
            return (
              <>
                {item.label === 'divider' ? (
                  <Divider />
                ) : (
                  <MenuItem
                    key={item.path || item.menuKey}
                    item={item}
                    isActive={isActive}
                    isOpen={openMenu === item.menuKey}
                    onChevronClick={handleChevronClick}
                    location={location}
                  />
                )}
              </>
            )
          })}
        </ul>
      </nav>
    </>
  )
}

export default LeftSideBarMenu
